<template>
  <!--выбор веса до нажатия на показать рец-->
  <div class="mt-2 text-left" >
    <b-form-group v-for="(item,index) in weights"  :key="index" :disabled=buttonDisabled>
      <b-form-radio style="font-family: 'Roboto Slab'" class="mt-2" v-model="selectWeight" @change="$emit('get_weight', selectWeight)"
                    :value="item.value">
        {{item.value}} {{recipe.data.base.packing}}
      </b-form-radio>
    </b-form-group>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "RadioSelectWeight",
  props: ['buttonDisabled', 'weights', 'selectWeight'],
  data(){
    return{

    }
  },
  computed: {
    ...mapGetters(['recipe']),

  },

  methods: {
    ...mapActions(['loadRecipe']),

  }
}
</script>

<style scoped>

</style>